(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["s24-size-helper"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('s24-size-helper')) {
  customElements.define('s24-size-helper', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized || !this.querySelector('[data-fallback]')) return;
      this.initialized = true;
      const launch = this.querySelector('[data-launch]');
      const panel = this.querySelector('.s24sh__panel');
      if (this.querySelector('[data-garment]')) {
      const method = this.querySelector('[data-method]') || { value: 'body', addEventListener() {} };
      const isShoe = this.dataset.shoe === 'true';
      const garment = this.querySelector('[data-garment]');
      const units = this.querySelector('[data-units]');
      const inputs = [...this.querySelectorAll('[data-measure]')];
      const refresh = () => {
        this.querySelectorAll('[data-guide]').forEach(el => { el.hidden = el.dataset.guide !== (isShoe ? 'shoes' : method.value); });
        this.querySelectorAll('[data-field-method]').forEach(el => { el.hidden = el.dataset.fieldMethod !== method.value || !el.dataset.garments.split(' ').includes(garment.value); });
      };
      method.addEventListener('change', refresh);
      garment.addEventListener('change', refresh);
      inputs.forEach(input => input.addEventListener('input', () => {
        const n = input.valueAsNumber;
        input.dataset.cm = Number.isFinite(n) && n > 0 ? String(units.value === 'cm' ? n : n * 2.54) : '';
      }));
      units.addEventListener('change', () => {
        this.querySelectorAll('[data-unit-label]').forEach(el => { el.textContent = units.value; });
        inputs.forEach(input => {
          const cm = Number(input.dataset.cm);
          input.value = cm > 0 ? String(Math.round((units.value === 'cm' ? cm : cm / 2.54) * 100) / 100) : '';
        });
      });
      this.querySelector('[data-inputs]').hidden = false;
      refresh();
      }
      if (typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
      const dialog = document.createElement('dialog');
      dialog.className = 's24sh__dialog';
      dialog.setAttribute('aria-labelledby', panel.querySelector('h2').id);
      dialog.append(panel);
      this.append(dialog);
      this.querySelector('[data-fallback]').hidden = true;
      launch.hidden = false;
      launch.setAttribute('aria-haspopup', 'dialog');
      const close = panel.querySelector('[data-close]');
      close.hidden = false;
      launch.addEventListener('click', () => { dialog.showModal(); close.focus(); this.dispatchEvent(new Event('s24-size-help-open')); });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => { this.dispatchEvent(new Event('s24-size-help-close')); launch.focus(); });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
